import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  sleighContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    pointerEvents: 'none',
    zIndex: 50,
    overflow: 'hidden',
  },
  sleigh: {
    position: 'absolute',
    fontSize: 28,
    whiteSpace: 'nowrap',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
    userSelect: 'none',
    pointerEvents: 'auto', // Permet les clics
    cursor: 'pointer',
  },
  gift: {
    position: 'fixed',
    fontSize: 24,
    pointerEvents: 'none',
    userSelect: 'none',
    zIndex: 9999,
    animation: '$giftFall ease-in forwards',
  },
  '@keyframes giftFall': {
    '0%': {
      transform: 'translateY(0) rotate(0deg)',
      opacity: 1,
    },
    '100%': {
      transform: 'translateY(calc(100vh + 50px)) rotate(720deg)',
      opacity: 0,
    },
  },
  // Animation de gauche à droite
  sleighLTR: {
    animation: '$flyLTR 12s linear forwards',
    transform: 'scaleX(-1)', // INVERSE le traîneau visuellement
  },
  // Animation de droite à gauche
  sleighRTL: {
    animation: '$flyRTL 12s linear forwards',
  },
  '@keyframes flyLTR': {
    '0%': {
      left: '-200px',
    },
    '100%': {
      left: 'calc(100vw + 200px)',
    },
  },
  '@keyframes flyRTL': {
    '0%': {
      right: '-200px',
      left: 'auto',
    },
    '100%': {
      right: 'calc(100vw + 200px)',
      left: 'auto',
    },
  },
  // Petite animation de flottement pour les rennes
  reindeer: {
    display: 'inline-block',
    animation: '$bob 0.8s ease-in-out infinite',
  },
  '@keyframes bob': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '50%': {
      transform: 'translateY(-3px)',
    },
  },
}))

const SantaSleigh = ({ enabled = true }) => {
  const classes = useStyles()
  const [isFlying, setIsFlying] = useState(false)
  const [direction, setDirection] = useState('rtl')
  const [key, setKey] = useState(0)
  const [topPosition, setTopPosition] = useState(20) // Position verticale aléatoire
  const [gifts, setGifts] = useState([])

  // Fonction pour créer une pluie de cadeaux
  const createGiftRain = (event) => {
    event.stopPropagation()
    
    // Créer 20-30 cadeaux qui tombent depuis le haut partout sur l'écran
    const numberOfGifts = 20 + Math.floor(Math.random() * 11)
    const newGifts = []
    
    for (let i = 0; i < numberOfGifts; i++) {
      const giftEmojis = ['🎁', '🎀', '🎄', '⭐', '🎉']
      const gift = {
        id: Date.now() + i + Math.random(), // ID unique
        emoji: giftEmojis[Math.floor(Math.random() * giftEmojis.length)],
        left: Math.random() * window.innerWidth, // Position aléatoire sur toute la largeur
        top: -50 - Math.random() * 100, // Commencer au-dessus de l'écran avec des hauteurs variées
        duration: 2 + Math.random() * 2, // Entre 2 et 4 secondes
        delay: Math.random() * 0.8, // Décalage jusqu'à 0.8s
      }
      newGifts.push(gift)
    }
    
    setGifts(prev => [...prev, ...newGifts])
    
    // Nettoyer les cadeaux après leur chute
    setTimeout(() => {
      setGifts(prev => prev.filter(g => !newGifts.find(ng => ng.id === g.id)))
    }, 10000)
  }

  useEffect(() => {
    if (!enabled) {
      setIsFlying(false)
      return
    }

    // Premier passage après 10-20 secondes
    const initialDelay = 10000 + Math.random() * 10000
    
    const startFlight = () => {
      // Alterne la direction
      setDirection(prev => prev === 'ltr' ? 'rtl' : 'ltr')
      setKey(prev => prev + 1)
      // Hauteur aléatoire entre 10% et 70% de la page visible
      setTopPosition(10 + Math.random() * 60)
      setIsFlying(true)
      
      // Cache le traîneau après l'animation (12s)
      setTimeout(() => {
        setIsFlying(false)
      }, 12500)
    }

    // Premier vol
    const initialTimer = setTimeout(() => {
      startFlight()
    }, initialDelay)

    // Vols suivants toutes les 45-90 secondes
    const interval = setInterval(() => {
      if (!isFlying) {
        startFlight()
      }
    }, 90000 + Math.random() * 90000)

    return () => {
      clearTimeout(initialTimer)
      clearInterval(interval)
    }
  }, [enabled])

  if (!enabled || !isFlying) return null

  return (
    <>
      <div className={classes.sleighContainer}>
        <div 
          key={key}
          className={`${classes.sleigh} ${direction === 'ltr' ? classes.sleighLTR : classes.sleighRTL}`}
          style={{ top: `${topPosition}%` }}
          onClick={createGiftRain}
        >
          <span className={classes.reindeer} style={{ animationDelay: '0s' }}>🦌</span>
          <span className={classes.reindeer} style={{ animationDelay: '0.1s' }}>🦌</span>
          <span style={{ margin: '0 2px' }}>✨</span>
          <span>🛷</span>
          <span>🎅</span>
        </div>
      </div>
      
      {/* Pluie de cadeaux */}
      {gifts.map(gift => (
        <div
          key={gift.id}
          className={classes.gift}
          style={{
            left: `${gift.left}px`,
            top: `${gift.top}px`,
            animationDuration: `${gift.duration}s`,
            animationDelay: `${gift.delay}s`,
          }}
        >
          {gift.emoji}
        </div>
      ))}
    </>
  )
}

export default SantaSleigh
